var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPersonalize = function SvgPersonalize(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 23"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75 4.91a.75.75 0 0 0-.75.75v12.5c0 .413.336.75.75.75h10.5a.75.75 0 0 0 .75-.75v-5.75h-1v5.5H6v-12h9.5v-1H5.75Zm4.592 6.83-.501.866.993-.118 1.11-.132.117-.014.099-.065 8.145-5.358a.75.75 0 0 0 .215-1.039l-.275-.417a.75.75 0 0 0-1.039-.215l-8.145 5.358-.099.065-.06.102-.56.968Z",
    fill: "#000"
  })));
};
export default SvgPersonalize;